{
  "hero": {
    "title": "Kontakt"
  },
  "intro": {
    "text": "Lassen Sie uns zusammenarbeiten! Egal ob Sie Videos, Designs oder digitale Lösungen benötigen, ich bin nur eine Nachricht entfernt. Füllen Sie das Formular unten aus oder kontaktieren Sie mich direkt – ich freue mich darauf, von Ihrem Projekt zu hören."
  },
  "form": {
    "title": "Senden Sie mir eine Nachricht",
    "fields": {
      "fullName": {
        "label": "Vollständiger Name"
      },
      "email": {
        "label": "E-Mail"
      },
      "message": {
        "label": "Nachricht"
      }
    },
    "submit": "Nachricht senden"
  },
  "direct": {
    "title": "Oder kontaktieren Sie mich direkt",
    "email": {
      "label": "E-Mail: octavian@khromatik.com",
      "tooltip": "E-Mail kopieren"
    }
  }
}
